import { createLogger } from '../../../helpers/loggerFacade';
import fixWebmBlobDuration from './fix-webm-duration';
import { getDurationFixPrefixChunkCount } from './get-duration-fix-prefix';

const logger = createLogger('download-record-fix-record-chunks');

type FixRecordChunksArgs = {
    chunks: Blob[];
    mimeType: string;
    duration: number;
};

export const fixRecordChunks = async ({ chunks, mimeType, duration }: FixRecordChunksArgs): Promise<Blob> => {
    let blob = new Blob(chunks, { type: mimeType });

    if (!chunks.length) {
        return blob;
    }

    // Фиксим продолжительность файла в хэдере
    try {
        const prefixChunkCount = getDurationFixPrefixChunkCount(chunks);
        if (prefixChunkCount <= 0) {
            return blob;
        }

        // Для исправления продолжительности файла берем стартовый префикс из нескольких чанков:
        // в реальных записях Segment/Info нередко не помещаются в самый первый chunk.
        const originalPrefixBlob = new Blob(chunks.slice(0, prefixChunkCount), { type: mimeType });
        const fixedBlob = await fixWebmBlobDuration(originalPrefixBlob, duration);

        if (!fixedBlob.size) {
            logger.event('Skip fixed duration prefix because it is empty', {
                additional: {
                    method: 'fixWebmDuration',
                    prefixChunkCount,
                    originalPrefixSize: originalPrefixBlob.size,
                },
            });

            return blob;
        }

        const sizeDelta = fixedBlob.size - originalPrefixBlob.size;
        if (sizeDelta !== 0) {
            logger.event('Apply fixed duration prefix with size delta', {
                additional: {
                    method: 'fixWebmDuration',
                    originalPrefixSize: originalPrefixBlob.size,
                    fixedPrefixSize: fixedBlob.size,
                    sizeDelta,
                    prefixChunkCount,
                },
            });
        }

        blob = new Blob([fixedBlob, ...chunks.slice(prefixChunkCount)], { type: mimeType });
    } catch (error) {
        logger.error(error, { method: 'fixWebmDuration' });
    }

    return blob;
};
